import React from 'react';
import PropTypes from 'prop-types';
import { Border } from 'components/MsnbcDaily/Border';
import { withTranslation } from 'lib/Locale/i18n';

import styles from './styles.module.scss';

function HeaderComponent(props) {
  const {
    description,
    title,
    t,
  } = props;

  return (
    <div className={styles.msnbcDailyHeader}>
      <Border />
      <div className={styles.inner}>
        <h2 className={styles.title}>
          {title || t('MSNBC Daily')}
        </h2>
        {description && (
          <div className={styles.description}>
            {description}
          </div>
        )}
      </div>
    </div>
  );
}

HeaderComponent.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
  t: PropTypes.func.isRequired,
};

HeaderComponent.defaultProps = {
  description: null,
  title: null,
};

const Header = withTranslation()(HeaderComponent);

export { Header };
